import { useState } from 'react';
import SectionLabel from '../ui/SectionLabel';
import SectionTitle from '../ui/SectionTitle';
import { useScrollReveal } from '../../hooks/useScrollReveal';
import { useAppContext } from '../../context/AppContext';
import { LandingTrans } from '../../utils/translations';
import Class from '../../assets/photos/class.png';
import Lib from '../../assets/photos/22.png';
import Online from '../../assets/photos/20.png';
import Goose from '../../assets/photos/park.png';

export default function FormatsSection() {
  const { language, isMobile } = useAppContext();
  const t = LandingTrans[language];
  const [ref, visible] = useScrollReveal();
  const [flippedCard, setFlippedCard] = useState(null);

  const formatCards = [
    {
      img: Class,
      title: t.formatLiveTitle,
      desc: t.formatLiveDesc,
      extra: t.formatLivePrice,
      link: t.formatLiveLink,
      href: '/schedule',
    },
    {
      img: Goose,
      title: t.formatParkTitle,
      desc: t.formatParkDesc,
      extra: t.formatParkPrice,
      link: t.formatParkLink,
      href: '/schedule',
    },
    {
      img: Online,
      title: t.formatClubTitle,
      desc: t.formatClubDesc,
      extra: t.formatClubPrice,
      link: t.formatClubLink,
      href: '/onlineClub',
    },
    {
      img: Lib,
      title: t.formatLibraryTitle,
      desc: t.formatLibraryDesc,
      extra: t.formatLibraryPrice,
      link: t.toLibrary,
      href: '/library',
    },
  ];

  return (
    <section
      ref={ref}
      className={`bg-warm-white py-16 md:py-30 px-6 md:px-20 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
    >
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          <div>
            <SectionLabel>{t.formatsLabel}</SectionLabel>
            <SectionTitle className="mt-4">
              {t.formatsTitle}<em className="italic text-clay">{t.formatsTitleEm}</em>{t.formatsTitleSuffix}
            </SectionTitle>
          </div>
          <p className="text-[17px] font-sans font-light text-ink-mid self-end">
            {t.formatsIntro}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
          {formatCards.map((card, idx) => (
            <div
              key={idx}
              className="relative group w-full h-80 [perspective:1000px] mx-auto"
              onClick={(e) => {
                if (isMobile && e.target.tagName !== 'BUTTON' && e.target.tagName !== 'A') {
                  setFlippedCard(flippedCard === idx ? null : idx);
                }
              }}
              onMouseEnter={() => { if (!isMobile) setFlippedCard(idx); }}
              onMouseLeave={() => { if (!isMobile) setFlippedCard(null); }}
              style={{ cursor: isMobile ? 'pointer' : 'default' }}
            >
              <div
                className={`relative w-full h-full transition-transform duration-700 [transform-style:preserve-3d] ${flippedCard === idx ? '[transform:rotateY(180deg)]' : ''} ${!isMobile ? 'group-hover:[transform:rotateY(180deg)]' : ''}`}
              >
                {/* Front */}
                <div className="absolute inset-0 bg-warm-white rounded-sm border border-sand-dark flex flex-col items-center justify-center p-6 [backface-visibility:hidden]">
                  <img src={card.img} alt={card.title} className="rounded-full w-24 h-24 object-cover mb-4" />
                  <h3 className="font-serif text-xl font-medium text-ink mb-2">{card.title}</h3>
                  <p className="text-sm font-sans font-light text-ink-mid mb-4 line-clamp-3">{card.desc}</p>
                  <div className="absolute bottom-4 right-5 text-xs text-ink-light md:hidden pointer-events-none select-none">⤷</div>
                </div>
                {/* Back */}
                <div className="absolute inset-0 bg-clay text-white rounded-sm border border-clay-dark flex flex-col items-center p-6 [transform:rotateY(180deg)] [backface-visibility:hidden]">
                  <div className="flex flex-col items-center justify-center text-center flex-1 min-h-0">
                    <h3 className="font-serif text-xl font-medium mb-4 text-white">{card.title}</h3>
                    <p className="text-sm text-white/90 font-sans font-light">{card.extra}</p>
                  </div>
                  <a
                    href={card.href}
                    className="border border-white px-4 py-2 rounded-sm hover:bg-warm-white hover:text-clay transition text-xs font-sans uppercase tracking-wider flex-shrink-0"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {card.link}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 bg-cream p-8 md:p-10 border border-sand-dark rounded-sm">
          <p className="text-sm font-sans font-light text-ink-mid">{t.formatsCta}</p>
        </div>
      </div>
    </section>
  );
}
